import React from "react";
import PropTypes from "prop-types";

import styles from "./styles.module.scss";

const Box = (props) => {
  const align = props.align || "left";
  const background = props.background || "none";
  const className = props.className || "";
  const corners = props.corners || "sharp";
  const profiling = props.profiling || "background";
  const size = props.size || "medium";
  const width = props.width || "auto";

  let refineProps = { ...props };
  delete refineProps.children;
  delete refineProps.className;
  delete refineProps.corners;
  delete refineProps.profiling;
  delete refineProps.size;
  delete refineProps.width;

  return (
    <props.element
      data-align={align}
      data-background={background}
      data-corners={corners}
      data-profiling={profiling}
      data-size={size}
      data-width={width}
      {...refineProps}
      className={`${styles.box} ${className}`}
    >
      {props.children}
    </props.element>
  );
};

Box.propTypes = {
  align: PropTypes.oneOf(["left", "center", "right"]),
  background: PropTypes.oneOf(["none", "noise"]),
  children: PropTypes.node,
  className: PropTypes.string,
  corners: PropTypes.oneOf(["rounded", "sharp", "circle"]),
  profiling: PropTypes.oneOf(["background", "border", "borderless", "shadow"]), // todo: add this
  size: PropTypes.oneOf(["small", "medium", "large"]),
  width: PropTypes.oneOf(["auto", "full"])
};

export default Box;
